"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  demurrageCalculation: {
    title: '滞期费计算器',
    DEMDETFee: 'DEM&DET Fee',
    date: '截至时间',
    tips_1: '*蓝色：截至今天费用',
    tips_2: '*红色：指定日期费用',
    tips_3: '*黑色：实际费用',
    tips_4: '(2) 计算结果仅供参考，不能作为最后付费依据; 无法得到结果的集装箱不代表未产生费用。',
    blCtNoNotNull: '提单号，箱号必填一个',
    portName: '港口',
    freeUntil: '免费截止',
    days: '用箱',
    overDays: '超期',
    demurrageType: '类型',
    agreementNo: '减免协议号'
  }
};